import IconButton from "@material-ui/core/IconButton";
import UtilsFncs from "utils/UtilsFncs.js";
import MaskAndValid from "utils/maskAndValid.js";
import { FileCopy, WhatsApp } from "@mui/icons-material";

const commonStyle = { marginLeft: 5, marginBottom: 1 };

export default function PhoneText({
  phone = "",
  showCopy,
  showWhatsapp = true,
}) {
  return (
    phone &&
    phone.trim() > "" && (
      <>
        {MaskAndValid.maskPhone(phone)}
        {showCopy && (
          <IconButton
            title="Copiar"
            size="small"
            onClick={() => {
              UtilsFncs.CopyToClipboard(phone);
            }}
          >
            <FileCopy fontSize="small" style={commonStyle} />
          </IconButton>
        )}
        {showWhatsapp && (
          <IconButton
            aria-label="whatsapp"
            size="small"
            href={MaskAndValid.formattLinkWhatsApp(phone)}
            target="_blank"
          >
            <WhatsApp fontSize="small" style={commonStyle} />
          </IconButton>
        )}
      </>
    )
  );
}
